(() => {

  const ROOT_SELECTOR =
    '.one-blog-home:not([data-one-blog-ready])';


  function init() {

    document
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(setupBlog);

  }


  function setupBlog(root) {

    root.dataset.oneBlogReady =
      'true';


    initArticleCount(root);

    initCategoryNavigation(root);

    initCategoryRails(root);

  }


  /* =========================================================
     ARTICLE COUNT
     ========================================================= */

  function initArticleCount(root) {

    const grid =
      root.querySelector(
        '[data-one-latest-grid]'
      );


    if (!grid) {
      return;
    }


    const cards =
      Array.from(
        grid.querySelectorAll(
          '[data-one-latest-card]'
        )
      );


    const control =
      root.querySelector(
        '[data-one-count-control]'
      );


    if (!cards.length) {
      return;
    }


    /*
     * If 10 or fewer articles exist,
     * no pagination/count control is required.
     */

    if (
      cards.length <= 10
    ) {

      cards.forEach(
        card => {
          card.hidden = false;
        }
      );


      if (control) {
        control.hidden = true;
      }


      return;
    }


    if (!control) {
      return;
    }


    const status =
      control.querySelector(
        '[data-one-count-status]'
      );


    const buttons =
      Array.from(
        control.querySelectorAll(
          '[data-one-count]'
        )
      );


    const total =
      cards.length;


    /*
     * Show:
     * all thresholds smaller than total,
     * plus the first threshold that reaches/exceeds total.
     *
     * Example:
     * 17 posts -> 10 / 25
     * 44 posts -> 10 / 25 / 50
     * 82 posts -> 10 / 25 / 50 / 100
     */

    let reachedTotal =
      false;


    buttons.forEach(
      button => {

        const value =
          Number(
            button.dataset.oneCount
          );


        if (reachedTotal) {

          button.hidden =
            true;

          return;

        }


        button.hidden =
          false;


        if (
          value >= total
        ) {

          reachedTotal =
            true;

        }

      }
    );


    function applyCount(value) {

      const requested =
        Number(value);


      const visible =
        Math.min(
          requested,
          total
        );


      cards.forEach(
        (card, index) => {

          card.hidden =
            index >= visible;

        }
      );


      buttons.forEach(
        button => {

          button.classList.toggle(
            'is-active',
            Number(
              button.dataset.oneCount
            ) === requested
          );

        }
      );


      if (status) {

        status.textContent =
          `A mostrar 1–${visible} de ${total} artigos`;

      }

    }


    buttons.forEach(
      button => {

        button.addEventListener(
          'click',
          () => {

            applyCount(
              button.dataset.oneCount
            );

          }
        );

      }
    );


    applyCount(10);

  }


  /* =========================================================
     CATEGORY NAVIGATION
     ========================================================= */

  function initCategoryNavigation(root) {

    const links =
      root.querySelectorAll(
        '.one-blog-categories-nav a[href^="#"]'
      );


    links.forEach(
      link => {

        link.addEventListener(
          'click',
          event => {

            const href =
              link.getAttribute(
                'href'
              );


            if (
              !href ||
              href === '#'
            ) {
              return;
            }


            const target =
              root.querySelector(
                href
              );


            if (!target) {
              return;
            }


            event.preventDefault();


            const headerOffset =
              105;


            const top =
              target
                .getBoundingClientRect()
                .top +
              window.scrollY -
              headerOffset;


            window.scrollTo({
              top,
              behavior:
                'smooth'
            });

          }
        );

      }
    );

  }


  /* =========================================================
     CATEGORY RAILS
     ========================================================= */

  function initCategoryRails(root) {

    const categories =
      root.querySelectorAll(
        '.one-blog-category'
      );


    categories.forEach(
      category => {

        if (
          category.dataset
            .oneInitialized ===
          'true'
        ) {
          return;
        }


        category.dataset
          .oneInitialized =
          'true';


        const viewport =
          category.querySelector(
            '[data-one-category-viewport]'
          );


        const track =
          category.querySelector(
            '.one-blog-category__track'
          );


        const prev =
          category.querySelector(
            '[data-one-rail-prev]'
          );


        const next =
          category.querySelector(
            '[data-one-rail-next]'
          );


        if (
          !viewport ||
          !track ||
          !prev ||
          !next
        ) {
          return;
        }


        const getScrollAmount =
          () => {

            const firstCard =
              track.querySelector(
                '.one-blog-card'
              );


            if (!firstCard) {

              return (
                viewport.clientWidth *
                .7
              );

            }


            const styles =
              window.getComputedStyle(
                track
              );


            const gap =
              parseFloat(
                styles.columnGap ||
                styles.gap ||
                0
              );


            return (
              firstCard
                .getBoundingClientRect()
                .width +
              gap
            );

          };


        const updateButtons =
          () => {

            const maxScroll =
              viewport.scrollWidth -
              viewport.clientWidth;


            prev.disabled =
              viewport.scrollLeft <= 4;


            next.disabled =
              viewport.scrollLeft >=
              maxScroll - 4;

          };


        prev.addEventListener(
          'click',
          () => {

            viewport.scrollBy({
              left:
                -getScrollAmount(),

              behavior:
                'smooth'
            });

          }
        );


        next.addEventListener(
          'click',
          () => {

            viewport.scrollBy({
              left:
                getScrollAmount(),

              behavior:
                'smooth'
            });

          }
        );


        viewport.addEventListener(
          'scroll',
          updateButtons,
          {
            passive:
              true
          }
        );


        window.addEventListener(
          'resize',
          updateButtons
        );


        updateButtons();

      }
    );

  }


  document.addEventListener(
    'DOMContentLoaded',
    init
  );


  document.addEventListener(
    'shopify:section:load',
    init
  );

})();